import { cn } from "@/components/podkit/lib/cn";
import { GripVertical } from "lucide-react";
import { forwardRef } from "react";
import * as ResizablePrimitive from "react-resizable-panels";

export const ResizablePanelGroup = forwardRef<
    ResizablePrimitive.ImperativePanelGroupHandle,
    React.ComponentProps<typeof ResizablePrimitive.PanelGroup>
>(({ className, ...props }, ref) => (
    <ResizablePrimitive.PanelGroup
        className={cn("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", className)}
        ref={ref}
        {...props}
    />
));
ResizablePanelGroup.displayName = "ResizablePanelGroup";

/**
 * This is a pixel based resizable element and is a wrapper around the `ResizablePrimitive.Panel` component.
 * If you need a pixel-based resizable element, use the {@link Resizable} component instead.
 */
export const ResizablePanel = ResizablePrimitive.Panel;

export const ResizableHandle = ({
    withHandle,
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
    withHandle?: boolean;
}) => {
    return (
        <ResizablePrimitive.PanelResizeHandle
            className={cn(
                "focus-visible:ring-ring relative flex items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
                "w-0 border-l border-border-subtle hover:border-border-strong active:border-border-strong",
                className,
            )}
            {...props}
        >
            {withHandle && (
                <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border-border-base bg-border-base">
                    <GripVertical className="h-2.5 w-2.5" />
                </div>
            )}
        </ResizablePrimitive.PanelResizeHandle>
    );
};
